/**
 * amaActivites Module
 */
 import Vue from 'vue';
 import Swal from 'sweetalert2';
 import AppConfig from "../../../constants/AppConfig";
 import {store} from "../../store";
 import router from '../../../router/router';
 import { apiModel, makeApiRequest } from "../../../api";



 
 //States
 const state = {
    medecins: [],
    alerte: {},
    alertes: [],
    urgences: [],
    searchpatient: [],
    statuts: [],
    url_moderator: "",
    url_patient: "",
    loader: false,
};

 //Getters
 const getters = {
    alerte: state => {
        return state.alerte
    },

    alertes: state => {
        return state.alertes
    },

    medecins: state => {
        return state.medecins
    },

    urgences: state => {
        return state.urgences
    },
    statuts: state => state.statuts,

    url_moderator: state => state.url_moderator,
    
    url_patient: state => state.url_patient,

    getLoader(state){
        return state.loader
    }
};

 //Actions
 const actions = {

    addDoctorToAlerte(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getAlerteHandler', response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload,  {"method" : "PATCH", "url" : "/v2/alertes/"+payload.args.alerte_id+"/assignMedecin"}, 
        localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getAlerte(context, payload) {
        function successCallback(response) {
            context.commit('getAlerteHandler', response.data);
            let notifications = [];
            if(Array.isArray(context.rootState.notificationCount.notifications)){
                notifications = context.rootState.notificationCount.notifications;
            }else if(Array.isArray(context.rootState.notificationCount.notifications.data)){
                notifications = context.rootState.notificationCount.notifications.data;
            }

            if(notifications.find(item => item.data.id == response.data.id)){
                context.dispatch('deleteAlertes', response.data.id, { root: true })
            }
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload, {"method" : "GET", "url" : "/v2/alertes/"+payload}, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getAlertes(context, payload) {
        function successCallback(response) {

            context.commit('getAlertesHandler', { alertes: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Alertes.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getMedecins(context, payload) {
        function successCallback(response) {
            // console.log(response.data);
            context.commit('getMedecinsHandler', { medecins: response.data.map(item => ({id: item.user_id, nom: item.user.name})) });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medecins.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getNiveauUrgence(context, payload) {
        function successCallback(response) {
            context.commit('getNiveauUrgenceHandler', { urgences: response.data.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Alertes.NiveauUrgence, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    listStatuts(context, payload) {
        function successCallback(response) {

            let statuts =  response.data.data.slice(0, 4);

            context.commit('getStatutsHandler', { statuts: statuts });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/v2/statuts"}, localToken, successCallback, errorCallback, payload.errorMessages);
    },






    searchPatients(context, payload) {
        function successCallback(response) {
            context.commit('searchPatientsHandler', { searchpatient: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Alertes.SearchPatient, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    // SearchPatient

    async createMalerte(context, payload) {
        function successCallback(response) {
            context.commit('getAlerteHandler', response.data);
            let data = [response.data, ...state.alertes.data];
            let alertes = {...state.alertes, data: data};
            context.commit('getAlertesHandler', { alertes: alertes });
            router.push({ name: 'alertes' });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'alertes' });

        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Alertes.Create.url;

        await Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.General.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    
    clearUrlUser(context){
        context.commit('getUrlModeratorHandler', "");
        context.commit('getUrlPatientHandler', "");
    },
    // create mettging and join it when user is control doctor
    createMettgingAndJoinAsModerator(context, payload) {
        context.commit('setLoader', true);
        function successCallback(response) {
            context.commit('getUrlModeratorHandler', response.data);
            context.commit('setLoader', false);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
            context.commit('setLoader', false);
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : `/v2/mettings/create/${payload.args.user_id}`}, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createMettgingAndJoinAsPatient(context, payload) {
        context.commit('setLoader', true);
        function successCallback(response) {
            context.commit('getUrlPatientHandler', response.data);
            context.commit('setLoader', false);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
            context.commit('setLoader', false);
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : `/v2/mettings/join/${payload.args.user_id}`}, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    //Update alerte
    updateAlerte(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            let data = state.alertes.data.map(item => item.id == response.data.id ? response.data : item);
            let alertes = {...state.alertes, data: data};

            context.commit('getAlertesHandler', { alertes: alertes });
            router.push({ name: 'alertes' });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Alertes.UpdateAlerte, localToken, successCallback, errorCallback, payload.errorMessages);
        makeApiRequest(payload.args, {"method" : "PATCH", "url" : "/v2/alertes/"+payload}, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    //Delete alerte
    deleteAlerte(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            let data = state.alertes.data.filter(item => item.id != response.data.id);
            let alertes = {...state.alertes, data: data};

            context.commit('getAlertesHandler', { alertes: alertes });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Alertes.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

 }

 //Mutations
 const mutations = {
    getAlerteHandler(state, alerte) {
        // Update alerte state
        state.alerte = alerte;
    },

    getUrlModeratorHandler(state, url_moderator) {
        state.url_moderator = url_moderator;
    },

    getUrlPatientHandler(state, url_patient) {
        state.url_patient = url_patient;
    },

    getAlertesHandler(state, { alertes }) {
        // Update alerte state
        state.alertes = alertes;
    },
    getStatutsHandler(state, { statuts }){
        state.statuts = statuts;
    },
    getMedecinsHandler(state, { medecins }) {
        // Update alerte state
        state.medecins = medecins;
    },
    getNiveauUrgenceHandler(state, { urgences }) {
        // Update alerte state
        state.urgences = urgences;
    },
    searchPatientsHandler(state, { searchpatient }) {
        // Update alerte state
        state.searchpatient = searchpatient;
    },

    setLoader(state, loader) {
        state.loader = loader;
    }

}


 export default {
    state,
    getters,
    actions,
    mutations
}






